import VolenteerSVG from '../assets/img/Helps/Volenteer.svg';
import CalldonatorSVG from '../assets/img/Helps/CallforDonation.svg';
import DonatorSVG from '../assets/img/Helps/Donation.svg';

const cardData = [
  {
    title: 'Become a Volunteer',
    description: 'Join our team and help us make a difference in the community.',
    image: VolenteerSVG,
    alt: 'Volunteer Icon',
  },
  {
    title: 'Call Donators',
    description: 'Reach out to us to learn how you can contribute to our cause.',
    image: CalldonatorSVG,
    alt: 'Call for Donation Icon',
  },
  {
    title: 'Send Donation',
    description: 'Your donations help us provide essential services to those in need.',
    image: DonatorSVG,
    alt: 'Donation Icon',
  },
];

export default cardData;